import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { BadgeMeta } from '../../services/badge';
import { alpha } from '@mui/material/styles';

const CompanyDirectoryBadges = ({
  badgeOption,
  isTPNAdminOrContentOwner = false,
  isUserServiceProvider = false,
}: {
  badgeOption: BadgeMeta
  isTPNAdminOrContentOwner: boolean;
  isUserServiceProvider: boolean;
}) => {
  if (badgeOption.expired && isUserServiceProvider) return null;

  return (
    <Tooltip key={badgeOption.label}
        title={
        ( isTPNAdminOrContentOwner ) ? (
        <>
            <Typography variant="body2" sx={{ display: 'flex', gap: 1 }}>
                <strong>{badgeOption.count}</strong> {badgeOption.tooltip}
            </Typography>
            <Typography variant="body2" sx={{ display: 'flex', gap: 1 }}>
                <strong>{ badgeOption.count_expired }</strong> Expired
            </Typography>
        </>
        ) : (
            <Typography variant="body2">{badgeOption.tooltip}</Typography>
        )
        }
        placement="bottom-start"
        >
        <Box
          sx={{
            position: 'relative',
            display: 'inline-flex',
            mr: 1,
            borderRadius: '50%',
            width: 53,
            height: 53,
            overflow: 'hidden',
            cursor: 'default',
            border: '1px solid rgba(0, 0, 0, 0.05)',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.10)',
            backgroundColor: '#fff',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
            <Box
                component="img"
                src={badgeOption?.image?.src}
                alt={badgeOption?.image?.alt}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                  p: 0.5,
                }}
            />
            {badgeOption.expired && (
            <Box
                sx={{
                  position: 'absolute',
                  bottom: 10,
                  textAlign: 'center',
                  bgcolor: (theme) => alpha(theme.palette.error.main, 0.9),
                  color: '#fff',
                  px: 0.5,
                  borderRadius: '2px',
                  fontSize: '0.65rem',
                  lineHeight: 1.25,
                  pointerEvents: 'none',
                  width: '100%',
                }}
            >
                Expired
            </Box>
            )}
        </Box>
    </Tooltip>
  );
};

export default CompanyDirectoryBadges;